import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/not-authorized',
    name: 'notAuthorized',
    component: () => import('@/views/restricted/NotAuthorizedView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout
    }
  }
]
